module.exports = __webpack_public_path__ + "img/champion.0fb4b036.png";